import React from 'react'
import { HighlightInit } from '@highlight-run/next/client'

import { API_URL } from '@/constants/api'

import { HighlightSetup, isHighlightEnabled } from './constants'

export function HighlightInitializer() {
  if (!isHighlightEnabled || !HighlightSetup.projectId) return null

  return (
    <HighlightInit
      projectId={HighlightSetup.projectId}
      serviceName={HighlightSetup.serviceName}
      tracingOrigins={[API_URL]}
      privacySetting="strict"
      networkRecording={{
        enabled: true,
        recordHeadersAndBody: true,
        urlBlocklist: [],
      }}
    />
  )
}
